import { ServiceType } from "@core/models/enums";

export function extractSortKey(sortKey: string) {
    if (!sortKey) return;
    const [corp, office] = sortKey.split("#");
    const corpPrefix = corp?.replace("corp_", "");
    const officeCd = office?.replace("office_", "");
    return {
        corpPrefix,
        officeCd
    }
}

export function extractServiceType(serviceType: string): number {
    // Reverse mapping of getServiceType from organization-management.component.ts
    // "1:入所系" → ServiceType.NYUSHO = 3
    // "2:通所系" → ServiceType.TSUSHO = 2
    // "3:特殊系" → ServiceType.TOKUSHU = 4
    // "4:小多機系" → ServiceType.SHOTAKI = 5
    if (!serviceType) return ServiceType.NOT_SUPPORT;

    if (serviceType.includes('1:入所系')) {
        return ServiceType.NYUSHO;
    } else if (serviceType.includes('2:通所系')) {
        return ServiceType.TSUSHO;
    } else if (serviceType.includes('3:特殊系')) {
        return ServiceType.TOKUSHU;
    } else if (serviceType.includes('4:小多機系')) {
        return ServiceType.SHOTAKI;
    }

    return ServiceType.NYUSHO; // Default to NYUSHO
}

export function formatDateToYYYYMMDD(date: Date | null): string {
    if (!date || isNaN(date.getTime())) {
        return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

  /**
  * Fake method IsNullOrEmpty of C#
  * @param value is anything
  * @returns is value null or empty(if values is string)
  */
  export function isNullOrEmpty(value: any): boolean {
      if (value === undefined || value === null) return true;
      if (value?.toString()?.trim() === '') return true;
      return false;
  }